module.exports = "/_next/static/resources/photo-4-38a7d4f52eeac6d57e2be207fda3b9ba.jpg";